import React, {useContext, useMemo, useState} from 'react'
import _ from 'lodash'
import {Input, Modal} from 'antd'
import {LoadingOutlined} from '@ant-design/icons'
import {FaPlus} from 'react-icons/fa6'
import {LoginContext} from 'components/LoginContext'
import useAsync from 'modules/asyncCache/useAsync'
import {familyBook_getMyFamilyForests_Api} from 'apis/familyBook'
import {InfoBanner} from './MomentRow'
import SendMomentNoticeModal from './SendMomentNoticeModal'

// "+ Thêm mới" - tạo 1 kỷ niệm HOÀN TOÀN TỰ DO (vd Lễ Thôi Nôi, Mừng Thọ) không xuất phát từ 1
// occurrence có sẵn trong "sắp đến" - cần chọn THÀNH VIÊN trước (SendMomentNoticeModal vốn luôn gắn
// với 1 member cụ thể). Nguồn thành viên: mọi "rừng" gia phả của tôi (familyBook_getMyFamilyForests_Api
// - đã dedupe qua family_person_id, đúng 1 nguồn liệt kê thành viên gộp duy nhất, không tự chế query
// riêng), gộp phẳng + tìm theo tên.
const CreateCustomMomentButton = ({t, onSuccess}) => {
    const login = useContext(LoginContext)
    const [pickerOpen, setPickerOpen] = useState(false)
    const [keyword, setKeyword] = useState('')
    const [selectedMember, setSelectedMember] = useState(null)

    const {response, isLoading} = useAsync({apiInfo: familyBook_getMyFamilyForests_Api, deps: [login?.id]})
    const forests = _.get(response, 'data.forests', [])
    const allMembers = useMemo(() => {
        const merged = forests.flatMap((f) => f.members || [])
        return _.uniqBy(merged, 'id')
    }, [forests])

    const filteredMembers = useMemo(() => {
        if (!keyword.trim()) return allMembers
        const needle = keyword.trim().toLowerCase()
        return allMembers.filter((m) => (m.name || '').toLowerCase().includes(needle))
    }, [allMembers, keyword])

    if (!login) return null

    return (
        <>
            <button
                type="button"
                onClick={() => setPickerOpen(true)}
                className="px-3 py-1.5 flex items-center gap-1.5 rounded-lg bg-family-600 hover:bg-family-700 text-white text-xs font-semibold cursor-pointer flex-shrink-0">
                <FaPlus size={11}/>
                {t('create custom moment')}
            </button>

            {pickerOpen && (
                <Modal
                    width={380}
                    className="custom-modal"
                    rootClassName="family-theme"
                    open={true}
                    title={<div className="text-center font-bold text-color-000 uppercase tracking-wide">{t('choose family member')}</div>}
                    destroyOnHidden
                    footer={null}
                    onCancel={() => setPickerOpen(false)}>
                    <div className="flex flex-col gap-2 pt-2">
                        <InfoBanner>{t('create_custom_moment_intro')}</InfoBanner>
                        <Input.Search
                            allowClear
                            placeholder={t('search by member name')}
                            onChange={(e) => setKeyword(e.target.value)}
                        />
                        {isLoading && !allMembers.length ? (
                            <div className="flex items-center justify-center py-8"><LoadingOutlined className="text-family-500"/></div>
                        ) : filteredMembers.length ? (
                            <div className="flex flex-col gap-1.5 max-h-96 overflow-y-auto">
                                {filteredMembers.map((m) => (
                                    <button
                                        key={m.id}
                                        type="button"
                                        onClick={() => { setSelectedMember(m); setPickerOpen(false) }}
                                        className="p-2.5 flex items-center gap-2 rounded-lg border border-color-50 hover:bg-family-50 cursor-pointer text-left bg-transparent">
                                        <span className="text-sm font-semibold text-color-000 truncate">{m.name}</span>
                                    </button>
                                ))}
                            </div>
                        ) : (
                            <p className="text-xs text-color-300 italic py-4 text-center">{t('no members found')}</p>
                        )}
                    </div>
                </Modal>
            )}

            {selectedMember && (
                <SendMomentNoticeModal
                    item={{member_id: selectedMember.id, member_name: selectedMember.name}}
                    t={t}
                    onClose={() => setSelectedMember(null)}
                    onSuccess={() => {
                        setSelectedMember(null)
                        onSuccess && onSuccess()
                    }}
                />
            )}
        </>
    )
}

export default CreateCustomMomentButton
